import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import {
  DeleteItemAttentionIcon,
  DeleteItemsKnowledgeBaseIcon,
} from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseIcons/CurrentKnowledgeBaseIcons';
import { Button } from 'src/components/ui/button';

export const DeleteProjectLinkPopup = ({
  link,
  disabled = false,
  deleteProjectLink = () => {},
}) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
  };

  const onClick = () => {
    deleteProjectLink();
    closePopup();
  };

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            className={'opacity-30 hover:opacity-80'}
          >
            <path
              d="M3.88878 19.5V5.33333H2.94434V3.44444H7.66656V2.5H13.3332V3.44444H18.0554V5.33333H17.111V19.5H3.88878ZM5.77767 17.6111H15.2221V5.33333H5.77767V17.6111ZM7.66656 15.7222H9.55545V7.22222H7.66656V15.7222ZM11.4443 15.7222H13.3332V7.22222H11.4443V15.7222Z"
              fill="#05050D"
              stroke="white"
              strokeWidth="0.2"
            />
          </svg>
        </div>
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle>Delete Website Link</DialogTitle>
        </DialogHeader>
        <div className="flex flex-row gap-4 pt-4">
          <div className={'flex justify-center items-center'}>
            <DeleteItemAttentionIcon />
          </div>
          <div>
            <p className={'text-delete font-medium text-base'}>
              Are you sure you want to delete this link {link.pf_page_url} ?
            </p>
          </div>
        </div>
        <div className="flex justify-center mt-5">
          <div className="flex gap-2.5">
            <Button variant="outline" type="button" className="min-w-24" onClick={closePopup}>
              Cancel
            </Button>
            <Button className="min-w-24" onClick={onClick}>
              Delete
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
